/**
 * @copyright NIIT Technologies Ltd. 2017-18.
 */
// Angular
import { NgModule, NgZone, Component, ElementRef, Renderer, Input, forwardRef, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';
// Core
import { ControlComponent } from '../../core/component/control.component';
import { NgcErrorModule } from '../error/ngc-error.component';
// JQX Widget
import { jqxListBoxComponent } from 'jqwidgets-framework/jqwidgets-ts/angular_jqxlistbox';

// Control Value Accessor
const CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR: any = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => NgcListBoxComponent),
    multi: true
};

/**
 * List Box
 */
@Component({
    selector: 'ngc-listbox',
    template: `<jqxListBox *ngIf="visible" #jqxListBox (onChange)="selectionChange($event)"
                [autoHeight] = "autoHeight"
                [allowDrag] = "allowDrag"
                [allowDrop] = "allowDrop"
                [checkboxes] = "checkboxes"
                [disabled] = "disabled"
                [displayMember] = "displayMember"
                [dropAction] = "dropAction"
                [dragStart] = "dragStart"
                [dragEnd] = "dragEnd"
                [enableHover] = "enableHover"
                [enableSelection] = "enableSelection"
                [equalItemsWidth] = "equalItemsWidth"
                [filterable] = "filterable"
                [filterHeight] = "filterHeight"
                [filterDelay] = "filterDelay"
                [filterPlaceHolder] = "filterPlaceHolder"
                [hasThreeStates] = "hasThreeStates"
                [itemHeight] = "itemHeight"
                [incrementalSearch] = "incrementalSearch"
                [incrementalSearchDelay] = "incrementalSearchDelay"
                [multiple] = "multiple"
                [multipleextended] = "multipleextended"
                [renderer] = "renderer"
                [rtl] = "rtl"
                [selectedIndex] = "selectedIndex"
                [selectedIndexes] = "selectedIndexes"
                [source] = "source"
                [scrollBarSize] = "scrollBarSize"
                [searchMode] = "searchMode"
                [theme] = "theme"
                [valueMember] = "valueMember"
                [width] = "width"
                [height] = "height">
                <ng-content></ng-content>
                </jqxListBox>
                <ngc-error *ngIf="visible" [value]="error"></ngc-error>
                `,
    providers: [CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR]
})
export class NgcListBoxComponent extends ControlComponent {
    @Input('autoHeight') autoHeight: any;
    @Input('allowDrag') allowDrag: any;
    @Input('allowDrop') allowDrop: any;
    @Input('checkboxes') checkboxes: any;
    @Input('displayMember') displayMember: any;
    @Input('dropAction') dropAction: any;
    @Input('dragStart') dragStart: any;
    @Input('dragEnd') dragEnd: any;
    @Input('enableHover') enableHover: any;
    @Input('enableSelection') enableSelection: any;
    @Input('equalItemsWidth') equalItemsWidth: any;
    @Input('filterable') filterable: any;
    @Input('filterHeight') filterHeight: any;
    @Input('filterDelay') filterDelay: any;
    @Input('filterPlaceHolder') filterPlaceHolder: any;
    @Input('hasThreeStates') hasThreeStates: any;
    @Input('itemHeight') itemHeight: any;
    @Input('incrementalSearch') incrementalSearch: any;
    @Input('incrementalSearchDelay') incrementalSearchDelay: any;
    @Input('multiple') multiple: any;
    @Input('multipleextended') multipleextended: any;
    @Input('renderer') renderer: any;
    @Input('rtl') rtl: any;
    @Input('selectedIndex') selectedIndex: any;
    @Input('selectedIndexes') selectedIndexes: any;
    @Input('source') source: any;
    @Input('scrollBarSize') scrollBarSize: any;
    @Input('searchMode') searchMode: any;
    @Input('theme') theme: any;
    @Input('valueMember') valueMember: any;
    @Input('width') width: any;
    @Input('height') height: any;
    @Input('auto-create') autoCreate: boolean = true;

    @ViewChild('jqxListBox') jqxListBox: jqxListBoxComponent;

    /**
     * Initialize
     */
    constructor(private ngZone: NgZone, private elementRef: ElementRef, private rendererRef: Renderer) {
        super(ngZone, elementRef, rendererRef);
    }

    /**
     * On Select
     * 
     * @param Event
     */
    selectionChange($e) {
        if (this.multiple) {
            let selectedItems: any[] = this.findSelectedItems();
            this.value = selectedItems;
        } else {
            this.value = $e.args.item.value;
        }
    }

    /**
     * Find Selected Items
     */
    findSelectedItems() {
        let selections = this.jqxListBox.getSelectedItems();
        let selectionArr = [];
        //
        for (let index = 0; index < selections.length; index++) {
            selectionArr = selectionArr.concat(selections[index].label);
        }
        return selectionArr;
    }
}

/**
 * List Box Module
 */
@NgModule({
    imports: [CommonModule, NgcErrorModule],
    exports: [NgcListBoxComponent],
    declarations: [NgcListBoxComponent, jqxListBoxComponent]
})
export class NgcListBoxModule {
}